import React from "react";
import PropTypes from "prop-types";
import ActionsCog from "../shared/general/ActionsCog";
import { Actions } from "./styles/engaged-styles";

const EngagedActions = (props) => {
  const {
    messageUrl,
    disengageUrl,
    disengageOnClick,
    recruiterId,
    recruiterCompanyName,
    engagementId,
    psl,
    addToPslOnClick,
    removeFromPslOnClick,
    jobId,
    isPortalEmployer,
  } = props;

  const messageAction = () => {
    window.location.href = messageUrl;
  };

  const cogActions = [
    {
      name: "Message",
      id: 1,
      clickAction: messageAction,
    },
    {
      name: "Disengage",
      id: 2,
      clickAction: () => {
        disengageOnClick(disengageUrl, engagementId, jobId);
      },
    },
    !isPortalEmployer &&
      psl && {
        name: "Remove From PSL",
        id: 3,
        clickAction: () => {
          removeFromPslOnClick(recruiterId, jobId, recruiterCompanyName);
        },
      },
    !isPortalEmployer &&
      !psl && {
        name: "Add To PSL",
        id: 4,
        clickAction: () => {
          addToPslOnClick(recruiterId);
        },
      },
  ];

  return (
    <Actions>
      <ActionsCog actions={cogActions} />
    </Actions>
  );
};

EngagedActions.propTypes = {
  messageUrl: PropTypes.string.isRequired,
  disengageUrl: PropTypes.string.isRequired,
  disengageOnClick: PropTypes.func.isRequired,
  psl: PropTypes.bool.isRequired,
  recruiterId: PropTypes.number.isRequired,
  engagementId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired,
  addToPslOnClick: PropTypes.func.isRequired,
  removeFromPslOnClick: PropTypes.func.isRequired,
  recruiterCompanyName: PropTypes.string,
  isPortalEmployer: PropTypes.bool.isRequired,
};

EngagedActions.defaultProps = {
  recruiterCompanyName: PropTypes.isNull,
};

export default EngagedActions;
